import { useEffect, useRef } from 'react';
import { useInView, useMotionValue, useSpring } from 'framer-motion';

export default function CountUp({
  to,
  from = 0,
  duration = 2,
  separator = '',
  decimals = 0,
  prefix = '',
  suffix = '',
  className = '',
}) {
  const ref = useRef(null);
  const motionValue = useMotionValue(from);
  const damping = 20 + 40 * (1 / duration);
  const stiffness = 100 * (1 / duration);
  const spring = useSpring(motionValue, { damping, stiffness });
  const inView = useInView(ref, { once: true, margin: '0px' });

  useEffect(() => {
    if (inView) motionValue.set(to);
  }, [inView, motionValue, to]);

  useEffect(() => {
    const unsub = spring.on('change', (latest) => {
      if (!ref.current) return;
      const fixed = Number(latest).toFixed(decimals);
      const withSep = separator
        ? Number(fixed).toLocaleString('en-US').replace(/,/g, separator)
        : fixed;
      ref.current.textContent = `${prefix}${withSep}${suffix}`;
    });
    return unsub;
  }, [spring, decimals, separator, prefix, suffix]);

  return (
    <span className={`rb-countup ${className}`} ref={ref}>
      {`${prefix}${from.toFixed(decimals)}${suffix}`}
    </span>
  );
}
